import styled from "styled-components";

/**
 * Shared error container for modal components.
 * Displays validation or API errors with a red-themed background.
 */
export const ErrorContainer = styled.div`
  background-color: #fdecea;
  border: 1px solid #f5c2c7;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #842029;
  font-size: 14px;
`;
